<div class="countryLanguage">
  <div class="countryFlag">
    <img [src]="imageUrl" loading="lazy" alt="{{ baseSite.uid }}" />
    <span>{{ baseSite.country?.nativeName }}</span>
  </div>
  <div>
    @if (baseSite.stores) {
      @for (
        language of baseSite.stores[0].languages;
        track trackByIsoCode($index, language)
      ) {
        <boels-language-selector-page-item-link
          (languageEventEmitter)="
            emitBaseSiteLanguage({ baseSite: baseSite, language: $event })
          "
          [baseSite]="baseSite"
          [language]="language"
          [urlAfterRedirects]="urlAfterRedirects"
        ></boels-language-selector-page-item-link>
      }
    }
  </div>
</div>
